import { createAsyncThunk } from "@reduxjs/toolkit";
import { IHistoryResponseData } from "./historyTypes";
import {
  deleteHistoryItemAPI,
  getHistoryListAPI,
} from "../../../processes/api/history";
import { RootState } from "../../store";

export const getHistoryListThunk = createAsyncThunk<
  IHistoryResponseData,
  { id: number; page?: number },
  { state: RootState }
>("ui/getHistoryListThunk:fetch", async ({ id, page = 1 }, { getState }) => {
  const state = getState();
  const { pageSize } = state.app;

  const response = await getHistoryListAPI({
    userId: id,
    pageSize,
    page,
  });

  return response.data;
});

export const deleteHistoryItemThunk = createAsyncThunk<
  IHistoryResponseData,
  string
>("ui/deleteHistoryItemThunk:fetch", async (configHash) => {
  const response = await deleteHistoryItemAPI(configHash);

  return response.data;
});
